// Nominatim — free OpenStreetMap geocoding, no API key required.
// Terms: max 1 req/s, valid User-Agent/Referer required.
const NOMINATIM_BASE = 'https://nominatim.openstreetmap.org';
const HEADERS = { 'Accept-Language': 'en' };

export async function searchPlaces(query, signal) {
  if (!query.trim()) return [];

  const params = new URLSearchParams({
    q: query,
    format: 'json',
    limit: '6',
    addressdetails: '1',
  });

  const res = await fetch(`${NOMINATIM_BASE}/search?${params}`, {
    headers: HEADERS,
    signal,
  });

  if (!res.ok) throw new Error('Search failed');

  const data = await res.json();
  return data.map(item => ({
    id: item.place_id,
    name: item.display_name,
    shortName: shortDisplayName(item),
    lat: parseFloat(item.lat),
    lng: parseFloat(item.lon),
    type: item.type,
  }));
}

export async function reverseGeocode(lat, lng) {
  const params = new URLSearchParams({
    lat: String(lat),
    lon: String(lng),
    format: 'json',
    zoom: '14',
    addressdetails: '1',
  });

  try {
    const res = await fetch(`${NOMINATIM_BASE}/reverse?${params}`, { headers: HEADERS });
    if (!res.ok) return null;
    const data = await res.json();
    return shortDisplayName(data);
  } catch {
    return null;
  }
}

// URL-safe slug, e.g. "United Kingdom" → "united-kingdom".
export function slugify(s) {
  return String(s || '')
    .toLowerCase()
    .normalize("NFD").replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Structured country/region for a coordinate — used to tag published content
// so it's discoverable by place. Returns { country, countryCode, region } or null.
export async function reverseCountry(lat, lng) {
  const params = new URLSearchParams({
    lat: String(lat),
    lon: String(lng),
    format: 'json',
    zoom: '8',
    addressdetails: '1',
  });
  try {
    const res = await fetch(`${NOMINATIM_BASE}/reverse?${params}`, { headers: HEADERS });
    if (!res.ok) return null;
    const data = await res.json();
    const a = data.address || {};
    return {
      country: a.country || null,
      countryCode: (a.country_code || '').toUpperCase() || null,
      region: a.state || a.region || a.county || null,
    };
  } catch {
    return null;
  }
}

function shortDisplayName(item) {
  const addr = item.address || {};
  return (
    addr.amenity ||
    addr.building ||
    addr.road ||
    addr.suburb ||
    addr.neighbourhood ||
    addr.city ||
    addr.town ||
    addr.village ||
    addr.county ||
    addr.state ||
    addr.country ||
    item.display_name?.split(',')[0] ||
    'Unknown location'
  );
}
